import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MenuWrapper = styled.div`
  .meatball-menu {
    padding: 0px;
    margin: 0px;
    min-width: 34px;
    height: 25px;
    border: 1px solid ${COLORS.primary_light_blue};
  }
`;

export const PopupBody = styled.div`
  width: 350px;
  padding: 12px 16px;
  margin: 8px 0px;
  border-radius: 4px;
  border: 1px solid ${COLORS.cirrus_black5};
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .close-icon {
    display: flex;
    justify-content: flex-end;
    padding: 0px;
    &:hover {
      background: none;
    }
  }

  .header-title {
    margin: 0px;
  }

  .card-title {
    margin: 0px;
  }

  .client-title-wrapper {
    width: 75%;
  }

  .full-width {
    width: 100%;
  }

  .parent-active {
    padding: 5px;
    background: ${COLORS.cirrus_green};
    border-radius: 5px;
    color: ${COLORS.cirrus_white};
    font-weight: 600;
  }

  .client-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: ${COLORS.cirrus_black1};
  }
`;
